// This file was generated by svgr, do not edit it.
import * as React from 'react'
import { clsx } from 'clsx'
import styles from '../Icon.module.css'
import {
  computeStrokeWidth,
  computeSize,
  getIconColorClassName,
} from '../helpers'
import type { IconProps, IconComponentRef } from '../helpers'
const NotePlusIcon = React.forwardRef(
  (
    { size, stroke, className, color, ...props }: IconProps,
    ref: IconComponentRef,
  ) => {
    const iconName = 'note-plus'
    const computedSize = computeSize(size)
    const computedStrokeWidth = computeStrokeWidth(computedSize, stroke)
    return (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={clsx(className, styles.base, getIconColorClassName(color))}
        data-icon={iconName}
        aria-hidden="true"
        strokeWidth={computedStrokeWidth}
        width={computedSize}
        height={computedSize}
        ref={ref}
        {...props}
      >
        <path
          d="M20.5 12.5V19.5C20.5 20.0304 20.2893 20.5391 19.9142 20.9142C19.5391 21.2893 19.0304 21.5 18.5 21.5L8.50001 21.5C8.18311 21.5008 7.86921 21.4388 7.5764 21.3176C7.28359 21.1964 7.01768 21.0185 6.79401 20.794L3.20601 17.206C2.98153 16.9823 2.80357 16.7164 2.68239 16.4236C2.56122 16.1308 2.49923 15.8169 2.50001 15.5L2.50001 5.5C2.50001 4.96957 2.71072 4.46086 3.0858 4.08579C3.46087 3.71071 3.96958 3.5 4.50001 3.5H11.5M9.5 21.5L9.5 15.6667C9.5 15.3572 9.37708 15.0605 9.15829 14.8417C8.9395 14.6229 8.64275 14.5 8.33333 14.5H2.5M15.5 5.5H18.5M18.5 5.5H21.5M18.5 5.5V2.5M18.5 5.5V8.5"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  },
)
NotePlusIcon.displayName = 'NotePlusIcon'
export { NotePlusIcon }
